"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _resolveAndCallStrategy = _interopRequireDefault(require("../resolveAndCallStrategy"));

var targetPartApply = function targetPartApply(ctx, rule, cartOrSubject, asyncCmp, strategyType, targetParts) {
  return /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var prev,
        _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            prev = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
            return _context2.abrupt("return", targetParts.length ? asyncCmp(targetParts.map(function (tp) {
              return /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", (0, _resolveAndCallStrategy.default)(ctx, strategyType, tp, rule, cartOrSubject));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
            })) : prev);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var _default = targetPartApply;
exports.default = _default;